import { DetailedProductFieldsFragment } from "client/graphql/storefront-api"
import { useAnimationContext } from "client/packages/animations/AnimationContext"
import { OverlaidAnimationStyle } from "client/packages/animations/types"
import { Dispatch, SetStateAction } from "react"

import { getDefaultVariantForProduct } from "../../utils/getDefaultVariantForProduct"
import { useCartContext, useShopifyCart } from "../cart/CartContext"
import { useShopContext } from "../ShopContext"

import { ProductTile } from "./ProductTile"

export type ShopifyProductTileProps = {
  product: DetailedProductFieldsFragment
  setCurrentProductId?: Dispatch<SetStateAction<string>>
  isFeatured?: boolean
}

export const ShopifyProductTile = ({
  product,
  setCurrentProductId,
  isFeatured,
}: ShopifyProductTileProps) => {
  const variant = getDefaultVariantForProduct(product)
  const imageUrl = product.images.nodes[0]?.url
  const soldOut = !product.availableForSale

  const { addItem, isLoading } = useShopifyCart()
  const { setAddedProduct } = useShopContext()
  const { onBuyNowClick: onBuyNow } = useCartContext()
  const { setOverlaidAnimation } = useAnimationContext()

  const onAddToCart = () => {
    addItem(variant).then((data) => {
      if (data.data?.cartLinesAdd?.userErrors.length === 0) {
        setAddedProduct({
          variant,
          quantity: 1,
        })
        setOverlaidAnimation(OverlaidAnimationStyle.HEARTS)
      }
    })
  }

  const onBuyNowClick = () => {
    onBuyNow(variant.id, 1)
  }

  return (
    <ProductTile
      title={product.title}
      price={variant.price.amount.toString()}
      priceCurrencyCode={variant.price.currencyCode}
      imageUrl={imageUrl}
      soldOut={soldOut}
      featured={isFeatured}
      addToCartLoading={isLoading}
      onClick={() => {
        setCurrentProductId(product.id)
      }}
      onAddToCartClick={onAddToCart}
      onBuyNowClick={onBuyNowClick}
    />
  )
}
